import { configureStore } from '@reduxjs/toolkit';
import usertokenReducer from './usertoken/usertokenSlice';
import { dataApi } from './data/dataSlice';
import { serviceApi } from './service/serviceSlice';
import { processingApi } from './processing/processingSlice';
import pipelineReducer from './pipeline/pipelineSlice';
import resultReducer from './results/resultsSlice';
import tutorialReducer from './tutorial/tutorialSlice'

export const store = configureStore({
  reducer: {
    pipeline: pipelineReducer,
    usertoken: usertokenReducer,
    tutorial: tutorialReducer,
    [dataApi.reducerPath]: dataApi.reducer,
    [serviceApi.reducerPath]: serviceApi.reducer,
    [processingApi.reducerPath]: processingApi.reducer,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(dataApi.middleware, serviceApi.middleware, processingApi.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type StoreType = typeof store;
